module.exports = __webpack_public_path__ + "img/yx_rm@2x.24830aa9.png";